import { i18n } from '@/i18n'
// icon 在这里
// https://element.eleme.cn/#/zh-CN/component/icon
export default [
  {
    title: i18n.t('menu.homePage'),
    icon: 'el-icon-s-home',
    route: { name: 'home' },
    can: []
  },
  {
    title: i18n.t('model.user'),
    icon: 'el-icon-user',
    route: { name: 'users.index' }
  },
  {
    title: i18n.t('model.order'),
    icon: 'el-icon-s-order',
    route: { name: 'orders.index' }
  },
  {
    title: i18n.t('model.productDesign'),
    icon: 'el-icon-picture-outline',
    children: [
      {
        title: i18n.t('model.productDesign'),
        route: { name: 'product_designs.index' }
      },
      {
        title: i18n.t('menu.productDesignDesignerAnalyses'),
        route: { name: 'product_design_designer_analyses.index' },
        can: 'product_designs.read_designer_analyses'
      },
      {
        title: i18n.t('menu.productDesignCompanyAnalyses'),
        route: { name: 'product_design_company_analyses.index' },
        can: 'product_designs.read_company_analyses'
      },
      {
        title: i18n.t('menu.productDesignUserEffectAnalyses'),
        route: { name: 'product_design_user_effect_analyses.index' },
        can: 'product_designs.read_user_effect_analyses'
      },
      {
        title: i18n.t('menu.productDesignStatistics'),
        route: { name: 'product_design_statistics' },
        can: 'product_designs.read_statistics'
      }
    ]
  },
  {
    title: i18n.t('model.product'),
    icon: 'el-icon-goods',
    children: [
      {
        title: i18n.t('model.product'),
        route: { name: 'products.index' }
      },
      {
        title: i18n.t('model.productCategory'),
        route: { name: 'product_categories.index' }
      },
      {
        title: i18n.t('model.optionType'),
        route: { name: 'option_types.index' }
      }
    ]
  },
  {
    title: i18n.t('model.company'),
    icon: 'el-icon-office-building',
    route: { name: 'companies.index' }
  },
  {
    title: i18n.t('model.company'),
    icon: 'el-icon-office-building',
    can: ['companies.read_current'],
    route: { name: 'companies.show', params: { id: 'current' } }
  },
  {
    title: i18n.t('model.rejectReason'),
    icon: 'el-icon-s-release',
    route: { name: 'reject_reasons.index' }
  },
  // 以下代码为generator插入代码的标记，请勿修改或删除
  // Generator menu
  {
    title: i18n.t('model.project'),
    icon: 'el-icon-s-goods',
    route: { name: 'projects.index' }
  },
  {
    title: i18n.t('model.adminUser'),
    icon: 'el-icon-view',
    route: { name: 'admin_users.index' }
  },
  {
    title: i18n.t('model.material'),
    icon: 'el-icon-menu',
    route: { name: 'materials.index' }
  },
  {
    title: i18n.t('model.warehouse'),
    icon: 'el-icon-s-shop',
    route: { name: 'warehouses.index' }
  },
  {
    title: i18n.t('model.virtualWarehouse'),
    icon: 'el-icon-view',
    route: { name: 'virtual_warehouses.index' }
  },
  {
    title: i18n.t('model.orderSnapshot'),
    icon: 'el-icon-edit',
    route: { name: 'order_snapshots.index' }
  },
  {
    title: i18n.t('model.notification'),
    icon: 'el-icon-bell',
    route: { name: 'notifications.index' }
  },
];
